<script setup lang="ts">
import HeaderLogo from '@/dashboard/vue/components/layout/Header/HeaderLogo.vue';
import { useHeaderMobile } from '@/dashboard/vue/components/layout/Header/useHeaderMobile';
import BurgerMenuIcon from '@/dashboard/vue/components/icons/BurgerMenuIcon.vue';

const { baseWorkspaceLink, toggleSideMenu } = useHeaderMobile();
</script>

<template>
  <div class="items-center justify-between py-s max-tablet:flex laptop:hidden">
    <div class="flex items-center">
      <router-link :to="baseWorkspaceLink">
        <span class="fill-black dark:fill-gray-700">
          <HeaderLogo />
        </span>
      </router-link>
    </div>

    <button class="z-[10002]" @click="toggleSideMenu">
      <BurgerMenuIcon class="stroke-black dark:stroke-gray-700" />
    </button>
  </div>
</template>
